import {
  RolesPermissionsFilterParams,
  RolesPermissionsResponse,
} from '@/types/rolesPermissions.types';
import axios from 'axios';
import api from '../instance';
export const API_URL = `/user-role`;

const getToken = () => localStorage.getItem('accessToken');

export const rolesPermissionsService = {
  getAllRolesDropdown: async (filters?: any) => {
    try {
      const res = await api.userApi.get<RolesPermissionsResponse>(`${API_URL}/filter-drop-down`, {
        params: filters,
        headers: {
          Authorization: `Bearer ${getToken()}`,
          'X-Mm-Service': 'mm-content-mgmt-svc',
          'ngrok-skip-browser-warning': 'true',
          'x-show-loader': 'true',
        },
      });
      return res.data;
    } catch (error: unknown) {
      if (error instanceof Error) throw error;
      throw new Error('Error get roles dropdown');
    }
  },

  getAllRoles: async (filters?: RolesPermissionsFilterParams) => {
    try {
      const res = await api.userApi.get<RolesPermissionsResponse>(`${API_URL}/`, {
        params: filters,
        headers: {
          Authorization: `Bearer ${getToken()}`,
          'X-Mm-Service': 'mm-content-mgmt-svc',
          'ngrok-skip-browser-warning': 'true',
          'x-show-loader': 'true',
        },
      });
      return res.data;
    } catch (error: unknown) {
      if (error instanceof Error) throw error;
      throw new Error('Error get All Roles');
    }
  },

  getRoleById: async (id: number) => {
    try {
      const res = await api.userApi.get(`${API_URL}/${id}`, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          'X-Mm-Service': 'mm-content-mgmt-svc',
          'x-show-loader': 'true',
        },
      });
      return res.data;
    } catch (error: unknown) {
      if (error instanceof Error) throw error;
      throw new Error('Error get role by id');
    }
  },

  deleteRole: async (id: string, deletedBy: string) => {
    try {
      const res = await axios.delete(`${API_URL}/${id}`, {
        params: { deletedBy },
        headers: {
          Authorization: `Bearer ${getToken()}`,
          'X-Mm-Service': 'mm-content-mgmt-svc',
          'x-show-loader': 'true',
        },
      });
      return res.data;
    } catch (error: unknown) {
      if (error instanceof Error) throw error;
      throw new Error('Error delete role');
    }
  },

  deleteRoleById: async (id: string) => {
    try {
      const res = await api.userApi.delete(`${API_URL}/${id}`, {
        // params: { deletedBy },
        headers: {
          Authorization: `Bearer ${getToken()}`,
          'X-Mm-Service': 'mm-content-mgmt-svc',
          'x-show-loader': 'true',
        },
      });
      return res.data;
    } catch (error) {
      if (error instanceof Error) throw error;
      throw new Error('Error delete role');
    }
  },

  exportRoles: async () => {
    try {
      const res = await api.userApi.get(`${API_URL}/bulk-export`, {
        responseType: 'blob',
      });
      return res.data;
    } catch (error) {
      if (error instanceof Error) throw error;
      throw new Error('Error exporting roles');
    }
  },

  updateRole: async (id?: number, data?: any) => {
    try {
      const res = await api.userApi.put(`${API_URL}/${id}`, data, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          'X-Mm-Service': 'mm-content-mgmt-svc',
          'x-show-loader': 'true',
        },
      });
      return res.data;
    } catch (error: unknown) {
      if (error instanceof Error) throw error;
      throw new Error('Error update role');
    }
  },
};
